export default {
  nav: {
    main: 'الرئيسية',
    ordersAndInvoices: 'الطلبات والفواتير',
    drafts: 'المسودات',
    automation: 'الأتمتة',
    workspace: 'مساحة العمل',
    templates: 'القوالب',
    delivery: 'التسليم',
    settings: 'الإعدادات',
    shippingLabels: 'ملصقات الشحن',
    subscriptions: 'الاشتراكات',
    support: 'الدعم',
    developer: 'المطور',
    writeReview: 'اكتب مراجعة',
    supportTicket: 'تذكرة دعم',
    welcomeTour: 'جولة ترحيبية',
    administratorConsole: 'لوحة تحكم المسؤول',
    logout: 'تسجيل الخروج',
  },
  dashboard: {
    pageTitle: 'الطلبات والفواتير',
    pageDescription: 'Manage your orders and invoices',
    title: 'الطلبات والفواتير',
    selectedOrders: '{count} طلبات محددة',
    completed: '% مكتمل',
    processing: 'جاري المعالجة، يرجى الانتظار...',
    bulkDownload: 'تنزيل مجمّع',
    upgradeBulkDownload: 'قم بترقية خطتك للتنزيل المجمّع',
    showFilters: 'إظهار الفلاتر',
    hideFilters: 'إخفاء الفلاتر',
    creatingInvoices: 'جاري إنشاء الفواتير، يرجى الانتظار...',
    bulkCreateInvoices: 'إنشاء فواتير مجمّعة',
    cannotCreateAutopilot: 'لا يمكنك إنشاء الفواتير يدوياً عندما يكون وضع الفوترة على الطيار الآلي.',
    exportInvoices: 'تصدير الفواتير أو الطلبات',
    capturePayments: 'تحصيل المدفوعات يدوياً',
    filterOrders: 'تصفية الطلبات',
    error: 'عذراً، حدث خطأ ما...',
    close: 'إغلاق',
    chooseDate: 'اختر تاريخاً',
    chooseIssueDate: 'اختر تاريخ إصدار للفواتير المحددة',
    cancel: 'إلغاء',
    createInvoices: 'إنشاء الفواتير',
    storno: 'Storno',
    bulkOrderCapture: 'تحصيل الطلبات المجمّع',
  },
  search: {
    createdBetween: 'تاريخ الإنشاء بين',
    modifiedBetween: 'تاريخ التعديل بين',
    orderNumber: 'رقم الطلب',
    invoiceNumber: 'رقم الفاتورة',
    refundNumber: 'رقم الاسترداد',
    customer: 'العميل',
    payment: 'الدفع',
    any: 'الكل',
    authorized: 'مصرح',
    pending: 'قيد الانتظار',
    paid: 'مدفوع',
    partiallyPaid: 'مدفوع جزئياً',
    refunded: 'مسترد',
    voided: 'ملغي',
    partiallyRefunded: 'مسترد جزئياً',
    unpaid: 'غير مدفوع',
    fulfillment: 'التنفيذ',
    fulfilled: 'تم الشحن',
    partial: 'جزئي',
    unfulfilled: 'لم يتم الشحن',
    loading: 'جاري تحميل الطلبات...',
    search: 'بحث',
  },
  orderList: {
    noCustomer: 'لا يوجد عميل',
    downloadOrder: 'تنزيل الطلب',
    deleteWarning: 'مهم! سيؤدي هذا إلى حذف جميع الفواتير والاستردادات التي تم إنشاؤها بعد التاريخ:',
    includingInvoice: 'بما في ذلك الفاتورة المحددة رقم',
    pressOk: 'اضغط موافق للمتابعة أو إلغاء للتراجع.',
    cannotCreateAutopilot: 'لا يمكنك إنشاء الفواتير يدوياً عندما يكون وضع الفوترة على الطيار الآلي.',
    createInvoice: 'إنشاء فاتورة لهذا الطلب',
    create: 'إنشاء',
    addCreditNote: 'إضافة إشعار دائن',
    createStorno: 'إنشاء فاتورة Storno',
    refund: 'استرداد',
    downloadInvoice: 'تنزيل هذه الفاتورة',
    download: 'تنزيل',
    default: 'افتراضي',
    downloadStorno: 'تنزيل فاتورة Storno/الإشعار الدائن',
    fulfillOrder: 'تنفيذ الطلب',
    orderNum: 'رقم الطلب',
    locPrefix: 'بادئة الموقع',
    invoiceNum: 'رقم الفاتورة',
    refundNum: 'رقم الاسترداد',
    customerCol: 'العميل',
    orderCreatedDate: 'تاريخ إنشاء الطلب',
    orderModifiedDate: 'تاريخ تعديل الطلب',
    delivered: 'تم التسليم',
    paymentStatus: 'حالة الدفع',
    fulfillmentStatus: 'حالة الشحن',
    totalOutstanding: 'إجمالي المبلغ المستحق',
    originalPrice: 'السعر الأصلي',
    noOrders: 'لا توجد طلبات في متجرك للحالة المحددة.',
    cannotCreateNoOrders: 'لا يمكنك إنشاء فواتير عندما لا توجد طلبات.',
    createOrdersFirst: 'يرجى إنشاء طلب واحد على الأقل والمحاولة مرة أخرى.',
    createOrders: 'إنشاء طلبات',
    loadingOrders: 'جاري التحميل...',
    paidManual: 'مدفوع - يدوي',
    paid: 'مدفوع',
    refunded: 'مسترد',
    pending: 'قيد الانتظار',
    partiallyPaid: 'مدفوع جزئياً',
    partiallyRefunded: 'مسترد جزئياً',
    fulfilled: 'تم الشحن',
    unfulfilled: 'لم يتم الشحن',
    deliveryPending: 'قيد الانتظار',
    deliverNow: 'تسليم الآن',
    deliveryPartial: 'جزئي',
    notDelivered: 'لم يتم التسليم',
    deliverAgain: 'تسليم مرة أخرى',
    deliveryDetails: 'تفاصيل التسليم',
    deliveryFailed: 'فشل التسليم',
    sent: 'مرسل',
    failed: 'فشل',
    toLabel: 'إلى',
    folderLabel: 'مجلد',
    open: 'مفتوح',
    invoice: 'فاتورة',
    creditNote: 'إشعار دائن',
    stornoLabel: 'إلغاء',
    unknown: 'غير معروف',
    googleDrive: 'Google Drive',
    clientsTablet: 'جهاز لوحي للعملاء',
    shippyPro: 'ShippyPro',
    emailChannel: 'البريد الإلكتروني',
    ftpChannel: 'FTP',
    revertToDate: 'العودة إلى هذا التاريخ',
    add: 'إضافة',
    close: 'إغلاق',
  },
  downloadDialog: {
    downloadType: 'تنزيل {type}...',
    selectTemplate: 'اختر قالباً واحداً من المعرض لتصدير الطلبات أو الفواتير أو فواتير Storno أو الإشعارات الدائنة.',
    getMoreTemplates: 'الحصول على المزيد من القوالب',
    createNewTemplate: 'إنشاء قالب جديد',
    allCreatedBetween: 'جميع {type} المنشأة بين',
    selectedType: '{type} المحددة',
    and: 'و',
    status: 'الحالة',
    any: 'الكل',
    open: 'مفتوح',
    closed: 'مغلق',
    cancelled: 'ملغى',
    paymentStatus: 'حالة الدفع',
    fulfillmentStatus: 'حالة الشحن',
    fulfilled: 'تم الشحن',
    partial: 'جزئي',
    unfulfilled: 'لم يتم الشحن',
    authorized: 'مصرح',
    pending: 'قيد الانتظار',
    paid: 'مدفوع',
    partiallyPaid: 'مدفوع جزئياً',
    refunded: 'مسترد',
    voided: 'ملغي',
    partiallyRefunded: 'مسترد جزئياً',
    unpaid: 'غير مدفوع',
    format: 'الصيغة',
    forLocation: 'للموقع',
    advancedOptions: 'خيارات متقدمة',
    exportHSCodes: 'تصدير رموز النظام المنسق للمخزون (أبطأ)',
    noteChrome: 'ملاحظة: للتنزيل الأمثل يُنصح باستخدام Chrome وتعطيل أي مانع إعلانات.',
    downloadIndividually: 'تنزيل فردي',
    downloadGrouped: 'تنزيل مجمّع',
  },
  templates: {
    pageTitle: 'القوالب',
    pageDescription: 'Customize your invoice templates',
    title: 'القوالب',
    installTranslated: 'تثبيت قالب مترجم',
    installTranslatedDesc: 'اختر لغة مختلفة بالنقر على هذا الزر.',
    createNew: 'إنشاء قالب جديد إذا لزم الأمر',
    createNewDesc: 'انقر على هذا الزر لإنشاء قالب جديد إذا لزم الأمر.',
    customize: 'تخصيص القوالب',
    customizeDesc: 'انقر على القالب الافتراضي لتخصيصه. يمكنك تغيير الشعار والألوان، وللمستخدمين المتقدمين، الكود البرمجي.',
    defaultTemplate: 'الفاتورة و Storno والإشعار الدائن (افتراضي)',
    logo: 'الشعار',
    colorPalette: 'لوحة الألوان',
    getColorPalettes: 'الحصول على لوحات ألوان',
    paperSize: 'حجم الورق',
    format: 'التنسيق',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'الاتجاه',
    landscape: 'أفقي',
    portrait: 'عمودي',
    margin: 'الهامش (سم)',
    unsavedChanges: 'تغييرات غير محفوظة',
    discard: 'تجاهل',
    save: 'حفظ',
  },
  labels: {
    pageTitle: 'ملصقات الشحن',
    pageDescription: 'Create and manage shipping labels',
    title: 'ملصقات الشحن',
    glsRequiresPro: 'ملصقات شحن GLS لدول شرق أوروبا تتطلب الخطة الاحترافية.',
    upgradeDesc: 'قم بالترقية إلى الخطة الاحترافية لإنشاء وإدارة ملصقات الشحن.',
    upgradePlan: 'قم بترقية خطتك',
    eeuGls: 'EEU GLS',
    enabled: 'مفعّل',
    country: 'الدولة',
    hungary: 'المجر',
    slovakia: 'سلوفاكيا',
    czech: 'التشيك',
    romania: 'رومانيا',
    slovenia: 'سلوفينيا',
    croatia: 'كرواتيا',
    senderId: 'معرّف المرسل',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    name: 'الاسم',
    city: 'المدينة',
    address: 'العنوان',
    zipCode: 'الرمز البريدي',
    contactPerson: 'جهة الاتصال',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    glsServices: 'خدمات GLS',
    expressService: 'خدمة سريعة',
    exchangeService: 'خدمة الاستبدال',
    smsService: 'خدمة الرسائل القصيرة',
    smsText: 'نص الرسالة القصيرة',
    preAdviceService: 'خدمة الإشعار المسبق',
    unsavedChanges: 'تغييرات غير محفوظة',
    discard: 'تجاهل',
    save: 'حفظ',
  },
  billing: {
    pageTitle: 'الفوترة',
    pageDescription: 'Manage your subscription and billing',
    title: 'الفوترة',
    subscriptionFor: 'خطة الاشتراك للمتجر',
    currentlySubscribed: 'أنت مشترك حالياً في',
    plan: 'خطة',
    cancelSubscription: 'إلغاء الاشتراك',
    upgradePlan: 'قم بترقية خطتك',
    professional: 'احترافي',
    proPriceMonthly: '$29.99 / شهرياً',
    upgrade: 'ترقية',
    includesAllStarter: 'يشمل جميع ميزات خطة المبتدئين، بالإضافة إلى:',
    proFeature1: 'حزمة الامتثال العالمي: بادئات حسب الموقع وترقيم تسلسلي مخصص',
    proFeature2: 'التوطين الذكي: رسائل بريد إلكتروني مترجمة تلقائياً ومرفقات PDF محلية',
    proFeature3: 'دورة مستندات B2B الكاملة: فواتير مبدئية وعروض أسعار B2B وإشعارات دائنة',
    proFeature4: 'مزامنة محاسبة B2B: دقة 3 منازل عشرية وعرض متعدد العملات',
    proFeature5: 'نسخ احتياطي تلقائي: نسخ الفواتير تلقائياً إلى خادم FTP آمن أو Google Drive',
    proFeature6: 'Shopify Flow: أتمتة إنشاء الفواتير والتسليم و Storno عبر مشغلات وإجراءات Flow',
    proFeature7: 'منطق ذكاء اصطناعي متقدم: استخدم الذكاء الاصطناعي على الجهاز لبنود تخطيط شرطية معقدة',
    proFeature8: 'تصدير UBL XML و ZUGFeRD / Factur-X (امتثال الفوترة الإلكترونية الأوروبية)',
    proFeature9: 'رموز EPC QR للمدفوعات الفورية عبر نقاط البيع المحمولة',
    proFeature10: 'ملصقات شحن GLS لدول شرق أوروبا',
    proFeature11: 'الاحتفاظ الضريبي للامتثال لمدة 7 سنوات',
    currentlyUsing: 'أنت تستخدم حالياً خطتنا',
    free: 'المجانية',
    subscriptionPlan: 'للاشتراك.',
    monthlyUsage: 'الاستخدام الشهري',
    monthlyGenerated: '{count} / 50 فاتورة هذا الشهر',
    monthlyLimitReached: 'تم الوصول إلى الحد الشهري. قم بالترقية إلى خطة المبتدئين لفواتير غير محدودة.',
    freePlan: 'الخطة المجانية',
    freeToInstall: 'مجاني للتثبيت',
    freeFeature1: 'حتى 50 فاتورة/طلب شهرياً',
    freeFeature2: 'الوصول إلى جميع القوالب المحددة مسبقاً (31+)',
    freeFeature3: 'مساعد الذكاء الاصطناعي الأساسي',
    freeFeature4: 'تنزيل وطباعة PDF قياسي',
    freeFeature5: 'حزمة المستندات القياسية (فواتير، قسائم تعبئة، إيصالات)',
    freeFeature6: 'الاحتفاظ الآمن بالفواتير لمدة 3 أشهر',
    starterPlan: 'خطة المبتدئين',
    starterPrice: '$9.99 / شهرياً',
    starterPricePerInvoice: '+ 3¢ لكل فاتورة يتم إنشاؤها',
    subscribe: 'اشترك',
    starterFeature1: 'فواتير وطلبات غير محدودة',
    starterFeature2: 'تسليم PDF تلقائي عبر البريد الإلكتروني',
    starterFeature3: 'وصول كامل إلى المحرر الهجين ومساعد الذكاء الاصطناعي',
    starterFeature4: 'تكامل Shopify POS والباركود',
    starterFeature5: 'Shopify Flow: مشغلات وإجراءات لأتمتة الفواتير',
    starterFeature6: 'تصدير UBL XML / PEPPOL و ZUGFeRD / Factur-X (امتثال الفوترة الإلكترونية)',
    starterFeature7: 'الاحتفاظ الآمن بالفواتير لمدة سنة واحدة',
    proTaxOverrides: 'تجاوزات ضريبية مخصصة: ضريبة القيمة المضافة / GST لكل منتج ومعدلات على مستوى SKU',
    unsavedChanges: 'تغييرات غير محفوظة',
    discard: 'تجاهل',
    save: 'حفظ',
  },
  autopilot: {
    pageTitle: 'الأتمتة',
    pageDescription: 'Automate invoice creation and management',
    title: 'الأتمتة',
    autoCreate: 'إنشاء الفواتير تلقائياً',
    disabled: 'معطّل (يدوي)',
    whenCreated: 'عند إنشاء الطلبات',
    whenFulfilled: 'عند تنفيذ الطلبات',
    whenPaid: 'عند دفع الطلبات',
    autoCreateDesc: 'سيتم إنشاء الفواتير في تاريخ إنشاء الطلبات أو تنفيذها أو دفعها.',
    autoStorno: 'إنشاء فواتير Storno تلقائياً',
    whenCancelled: 'عند إلغاء الطلبات أو استردادها',
    autoStornoDesc: 'سيتم إنشاء فواتير Storno في تاريخ إلغاء الطلبات أو إنشاء الاستردادات.',
    cannotAutoFree: 'لا يمكن إنشاء الفواتير تلقائياً مع الخطة المجانية.',
    upgradePlan: 'قم بترقية خطتك',
    unsavedChanges: 'تغييرات غير محفوظة',
    discard: 'تجاهل',
    save: 'حفظ',
  },
  delivery: {
    pageTitle: 'التسليم',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'التسليم',
    settings: 'الإعدادات',
    useOrderNumbers: 'استخدام أرقام الطلبات لأسماء الملفات',
    sendIfCountry: 'إرسال إذا كانت دولة عنوان الفوترة هي',
    countryCodesHint: 'أدرج جميع رموز الدول مفصولة بفاصلة منقوطة.',
    sendForTags: 'إرسال للعملاء الذين لديهم أحد الوسوم المدرجة',
    tagsHint: 'أدرج جميع الوسوم مفصولة بفاصلة منقوطة.',
    emailDelivery: 'تسليم البريد الإلكتروني',
    sendAsPdf: 'إرسال الفواتير كمرفقات PDF للعملاء',
    autoSend: 'إرسال تلقائي عند إنشاء فاتورة',
    subject: 'الموضوع',
    body: 'النص',
    xmlAttachments: 'مرفقات XML',
    attachUbl: 'إرفاق UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'إرفاق ZUGFeRD / Factur-X XML',
    sendTestEmail: 'إرسال بريد إلكتروني تجريبي',
    sending: 'جاري الإرسال...',
    customSmtp: 'خادم SMTP مخصص',
    customSmtpDesc: 'استخدم خادم البريد الخاص بك بدلاً من الافتراضي',
    enableSmtp: 'تفعيل SMTP المخصص',
    smtpHost: 'مضيف SMTP',
    port: 'المنفذ',
    useSsl: 'استخدام SSL/TLS',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    fromEmail: 'البريد الإلكتروني للمرسل',
    fromName: 'اسم المرسل',
    shopifyLiquid: 'قالب Shopify Liquid',
    pasteInto: 'الصق هذا في',
    orderConfirmation: 'قالب تأكيد الطلب',
    toAddLink: 'لإضافة رابط تنزيل.',
    downloadInvoice: 'تنزيل فاتورتك',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'إرسال الطلبات إلى ClientsTablet عند إنشاء الفواتير',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'إرسال فواتير PDF كمستندات جمركية إلى ShippyPro للدول خارج الاتحاد الأوروبي',
    ftpBackup: 'نسخ احتياطي FTP / SFTP',
    ftpDesc: 'نسخ الفواتير تلقائياً إلى خادمك',
    enableFtp: 'تفعيل النسخ الاحتياطي التلقائي عبر FTP',
    host: 'المضيف',
    useSftp: 'استخدام SFTP (آمن)',
    destinationFolder: 'مجلد الوجهة',
    xmlFiles: 'ملفات XML',
    includeUbl: 'تضمين UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'تضمين ZUGFeRD / Factur-X XML',
    testConnection: 'اختبار الاتصال',
    testing: 'جاري الاختبار...',
    pro: 'PRO',
    upgradeFtp: 'قم بالترقية إلى الخطة الاحترافية لنسخ الفواتير تلقائياً إلى خادم FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'مزامنة الفواتير تلقائياً إلى Drive الخاص بك',
    connected: 'متصل',
    disconnect: 'قطع الاتصال',
    notWorking: 'لا يعمل؟ اذهب إلى',
    googlePermissions: 'أذونات Google',
    removeThenReconnect: 'قم بإزالة Invoice Browse، ثم أعد الاتصال.',
    connectGoogleDrive: 'ربط Google Drive',
    upgradeGoogleDrive: 'قم بالترقية إلى الخطة الاحترافية لمزامنة الفواتير تلقائياً إلى Google Drive.',
    unsavedChanges: 'تغييرات غير محفوظة',
    discard: 'تجاهل',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'حفظ',
  },
  bookkeeping: {
    pageTitle: 'الإعدادات',
    pageDescription: 'Configure your invoice settings',
    title: 'الإعدادات',
    owner: 'المالك',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    keepDifferentNumbering: 'الاحتفاظ بترقيم فواتير مختلف لكل موقع طلب',
    keepDifferentNumberingDisabled: 'الاحتفاظ بترقيم فواتير مختلف لكل موقع طلب غير متاح مع خطتك الحالية.',
    locationEmailDesc: 'يتيح لك هذا إرسال رسائل بريد إلكتروني وفواتير مترجمة بناءً على موقع الطلب: موقع المخزون أو عنوان الشحن أو عنوان الفوترة',
    upgradePlan: 'قم بترقية خطتك',
    matchingCriteria: 'معايير المطابقة',
    locationId: 'معرّف الموقع',
    shippingCountryCode: 'رمز دولة عنوان الشحن',
    billingCountryCode: 'رمز دولة عنوان الفوترة',
    matchLocationDesc: 'مطابقة الموقع بناءً على معرّف موقع الطلب أو رمز دولة عنوان الشحن أو الفوترة.',
    companyInfo: 'معلومات الشركة',
    name: 'الاسم',
    website: 'الموقع الإلكتروني',
    registrationNumber: 'رقم التسجيل',
    taxId: 'الرقم الضريبي',
    addressSection: 'العنوان',
    streetName: 'اسم الشارع',
    streetNumber: 'رقم الشارع',
    zip: 'الرمز البريدي',
    city: 'المدينة',
    region: 'المنطقة',
    country: 'الدولة',
    bankingInfo: 'المعلومات البنكية',
    bankName: 'اسم البنك',
    swift: 'Swift',
    currency: 'العملة',
    iban: 'IBAN',
    invoicing: 'الفوترة',
    decimalPlaces: 'المنازل العشرية',
    invoicesPrefix: 'بادئة الفواتير',
    currentInvoiceNumber: 'رقم الفاتورة الحالي',
    creditNotesPrefix: 'بادئة الإشعارات الدائنة',
    currentCreditNoteNumber: 'رقم الإشعار الدائن الحالي',
    lastInvoiceDate: 'تاريخ آخر فاتورة',
    noInvoicesYet: 'لم يتم إنشاء فواتير بعد.',
    confirmReverting: 'تأكيد استعادة النظام',
    allInvoicesAfter: 'جميع الفواتير وفواتير Storno الصادرة بعد',
    willBeRemoved: 'ستتم إزالتها. هل تريد المتابعة في استعادة النظام؟',
    cancel: 'إلغاء',
    revert: 'استعادة',
    revertDesc: 'استعادة النظام ستؤدي إلى مسح جميع الفواتير المنشأة بعد التاريخ المحدد.',
    revertToDate: 'استعادة إلى هذا التاريخ',
    reverting: 'جاري استعادة النظام، يرجى الانتظار...',
    useOrderNumbering: 'استخدام ترقيم الطلبات',
    showVat: 'إظهار ضريبة القيمة المضافة على الفواتير',
    overrideTaxes: 'تجاوز الضرائب',
    pricesIncludeTax: 'الأسعار تشمل الضريبة',
    productsTaxRate: 'معدل ضريبة المنتجات',
    shippingTaxRate: 'معدل ضريبة الشحن',
    skusSeparated: 'رموز SKU مفصولة بفاصلة منقوطة',
    skusTaxRate: 'معدل ضريبة SKU',
    useOrderDates: 'استخدام تواريخ إنشاء الطلبات للفواتير',
    convertCurrency: 'تحويل الأسعار إلى العملة التي يدفع بها العميل',
    unsavedChanges: 'تغييرات غير محفوظة',
    discard: 'تجاهل',
    save: 'حفظ',
  },
  drafts: {
    pageTitle: 'المسودات',
    pageDescription: 'Manage your draft orders',
    title: 'المسودات',
    download: 'تنزيل',
    newDraft: 'مسودة جديدة',
    exporting: 'جاري التصدير {status}%...',
    accessNotGranted: 'لم يتم منح صلاحية الوصول إلى مسودات الطلبات. يرجى',
    reLogin: 'إعادة تسجيل الدخول',
    toGrantPermissions: 'لمنح أذونات "مسودات الطلبات" المطلوبة.',
    pushFailed: 'فشل الإرسال إلى Shopify:',
    exportError: 'خطأ في التصدير:',
    confirmDelete: 'هل أنت متأكد أنك تريد حذف هذه المسودة؟',
    incompleteCustomer: 'بيانات العميل غير مكتملة:',
    pushWithoutCustomer: 'سيتم إرسال المسودة إلى Shopify بدون بيانات العميل. هل تريد المتابعة؟',
    customerNotInShopify: 'هذا العميل غير موجود في Shopify بعد.',
    warnings: 'تحذيرات:',
    createCustomerAndPush: 'إنشاء العميل في Shopify وإرسال مسودة الطلب؟',
    downloadTitle: 'تحميل المسودات',
    cancel: 'إلغاء',
  },
  draftEdit: {
    number: "الرقم",
    prefix: "البادئة",

    newDraft: 'مسودة جديدة',
    editDraft: 'تعديل المسودة',
    viewInShopify: 'عرض في Shopify',
    back: 'رجوع',
    createDraft: 'إنشاء مسودة',
    saveChanges: 'حفظ التغييرات',
    documentType: 'نوع المستند',
    draftOrder: 'مسودة طلب',
    quote: 'عرض سعر',
    proforma: 'فاتورة مبدئية',
    manualInvoice: 'فاتورة يدوية',
    currency: 'العملة',
    expiryDate: 'تاريخ الانتهاء',
    status: 'الحالة',
    draft: 'مسودة',
    sent: 'مُرسل',
    accepted: 'مقبول',
    customer: 'العميل',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    company: 'الشركة',
    taxId: 'الرقم الضريبي',
    billingAddress: 'عنوان الفوترة',
    address: 'العنوان',
    aptSuite: 'شقة/جناح',
    city: 'المدينة',
    province: 'المحافظة',
    countryField: 'الدولة',
    zip: 'الرمز البريدي',
    shippingAddress: 'عنوان الشحن',
    sameAsBilling: 'نفس عنوان الفوترة',
    lineItems: 'بنود الفاتورة',
    shipping: 'الشحن',
    shippingTitle: 'العنوان',
    shippingPlaceholder: 'مثال: شحن قياسي',
    price: 'السعر',
    note: 'ملاحظة',
    notePlaceholder: 'ملاحظة داخلية أو رسالة للعميل...',
    summary: 'الملخص',
    subtotal: 'المجموع الفرعي',
    discounts: 'الخصومات',
    tax: 'الضريبة',
    total: 'الإجمالي',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'أدخل عنوان متجرك',
    loginWith: 'تسجيل الدخول باستخدام',
    createAccount: 'إنشاء حساب جديد',
    placeholder: 'اسم-متجرك',
    shopRequired: 'اسم المتجر مطلوب',
    login: 'تسجيل الدخول',
    shopify: 'Shopify',
    terms: 'الشروط والأحكام',
    privacy: 'سياسة الخصوصية',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'هل تستمتع باستخدام Invoice Browse؟',
    description: 'لقد أنشأت فواتيرك الأولى! إذا وجدت التطبيق مفيداً، فإن مراجعة سريعة على متجر تطبيقات Shopify تساعدنا كثيراً.',
    reward: 'كشكر لك، سنعيد تعيين عداد الاستخدام الشهري إلى 0',
    leaveReview: 'اترك مراجعة',
    maybeLater: 'ربما لاحقاً',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'مرحباً بك في Invoice Browse',
    welcomeContent: 'دعني أريك كيف يمكنك استخدامه.',
    dashboardTitle: 'لوحة التحكم',
    dashboardContent: 'الشاشة التي تراها هي لوحة التحكم الرئيسية. هنا يمكنك العثور على جميع الطلبات ويمكنك تصديرها إلى أنواع مستندات مختلفة مثل: الفواتير وقسائم التعبئة وغيرها.',
    automationTitle: 'اجعل حياتك أسهل',
    automationContent: 'قم بتفعيل الأتمتة لإنشاء الفواتير تلقائياً عند دفع الطلبات أو استردادها.',
    templatesTitle: 'تخصيص القوالب',
    templatesContent: 'ادخل هنا لترجمة قالبك أو تخصيصه أو إنشاء قالب جديد.',
    deliveryTitle: 'التسليم',
    deliveryContent: 'قم بإعداد تطبيقنا لنسخ المستندات المنشأة تلقائياً إلى FTP أو Google Drive أو كمرفقات للبريد الإلكتروني.',
    settingsTitle: 'الإعدادات',
    settingsContent1: 'قم بضبط رقم هاتف الشركة والبريد الإلكتروني والحقول الأخرى المستخدمة في المستندات.',
    settingsContent2: 'قم بتغيير رقم بداية المستندات أو مسح المستندات المنشأة بعد تاريخ معين.',
    settingsContent3: 'تجاوز معدلات ضريبة القيمة المضافة للشحن والمنتجات',
    settingsContent4: 'تغيير المنازل العشرية للأرقام',
    reviewTitle: 'اكتب مراجعة',
    reviewContent: 'ادعم فريقنا بكتابة مراجعة جيدة!',
    tourTitle: 'جولة ترحيبية',
    tourContent: 'يمكنك فتح هذه الجولة مرة أخرى من هنا.',
    createDocTitle: 'أنشئ مستندك الأول',
    createDocContent: 'انقر على زر إنشاء لإنشاء مستندك الأول.',
    docNumberTitle: 'رقم المستند',
    docNumberContent: 'المستند الأول يحمل الرقم 1. إذا أردت البدء برقم آخر يمكنك تغيير ذلك من الإعدادات.',
    downloadDocTitle: 'تنزيل المستند',
    downloadDocContent: 'انقر على القائمة المنسدلة للتنزيل واختر قالب مستند لتصدير طلبك كملف PDF.',
  },
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    discard: 'تجاهل',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    loading: 'جاري التحميل...',
    unsavedChanges: 'تغييرات غير محفوظة',
    upgradePlan: 'قم بترقية خطتك',
  },
  languageSelector: {
    label: 'اللغة',
    auto: 'اكتشاف تلقائي',
  },
  draftList: {
    draftNum: 'مسودة #',
    shopifyId: 'Shopify ID',
    type: 'النوع',
    customer: 'العميل',
    total: 'المجموع',
    status: 'الحالة',
    delivered: 'تم التسليم',
    date: 'التاريخ',
    actions: 'الإجراءات',
    noCustomer: 'لا يوجد عميل',
    noDrafts: 'لم يتم العثور على مسودات أو عروض أسعار.',
    loading: 'جاري التحميل...',
    download: 'تحميل',
    default: 'افتراضي',
    pending: 'قيد الانتظار',
    deliverNow: 'تسليم الآن',
    deliveryDetails: 'تفاصيل التسليم',
    sent: 'مُرسل',
    failed: 'فشل',
    deliverAgain: 'إعادة التسليم',
    partial: 'جزئي',
    notDelivered: 'لم يتم التسليم',
    deliveryFailed: 'فشل التسليم',
    unknown: 'غير معروف',
    edit: 'تعديل',
    send: 'إرسال',
    pushToShopify: 'إرسال إلى Shopify',
    complete: 'إكمال',
    duplicate: 'تكرار',
    delete: 'حذف',
    quote: 'عرض سعر',
    proforma: 'فاتورة مبدئية',
    draftOrder: 'طلب مسودة',
    manualInvoice: 'فاتورة يدوية',
  },
  draftSearch: {
    createdBtw: 'أُنشئ بين',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'العميل',
    status: 'الحالة',
    type: 'النوع',
    delivery: 'التسليم',
    any: 'الكل',
    draft: 'مسودة',
    sent: 'مُرسل',
    accepted: 'مقبول',
    expired: 'منتهي',
    converted: 'محوّل',
    cancelled: 'ملغى',
    quote: 'عرض سعر',
    proforma: 'فاتورة مبدئية',
    draftOrder: 'طلب مسودة',
    manualInvoice: 'فاتورة يدوية',
    delivered: 'تم التسليم',
    notDelivered: 'لم يتم التسليم',
    pending: 'قيد الانتظار',
    search: 'بحث',
  },
  draftDownload: {
    title: 'تحميل مسودة #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'الحالة',
    documentType: 'النوع',
    any: 'الكل',
    draft: 'مسودة',
    sent: 'مُرسل',
    accepted: 'مقبول',
    expired: 'منتهي',
    converted: 'محوّل',
    cancelled: 'ملغى',
    quote: 'عرض سعر',
    proforma: 'فاتورة مبدئية',
    draftOrder: 'طلب مسودة',
    manualInvoice: 'فاتورة يدوية',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'تثبيت قالب جديد',
    tabStyle: 'النمط',
    tabContent: 'المحتوى',
    tabTranslations: 'الترجمات',
    tabSettings: 'الإعدادات',
    tabCode: 'الكود',
    tabCopilot: 'مساعد الذكاء الاصطناعي',
    logo: 'الشعار',
    colorPalette: 'لوحة الألوان',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/ar.js